// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../app/assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../app/assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../app/assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../app/assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../app/assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../app/assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../app/assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../app/assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../app/assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.AddComment_scroll__Shb2V::-webkit-scrollbar {
  height: 8px;
}
.AddComment_scroll__Shb2V::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.AddComment_scroll__Shb2V::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.AddComment_AddComment__1hiic {
  position: absolute;
  bottom: 10px;
  z-index: 1282;
}
.AddComment_AddComment_removePosition__bdoTf {
  position: relative;
  top: auto;
  top: initial;
  bottom: auto;
  bottom: initial;
}
body[dir=ltr] .AddComment_AddComment__1hiic {
  right: 10px;
}
body[dir=rtl] .AddComment_AddComment__1hiic {
  left: 10px;
}
.AddComment_AddComment__1hiic .AddComment_CommentContainer__Y7wQ8 {
  max-height: 130px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.AddComment_AddComment__1hiic .AddComment_CommentContainer__Y7wQ8::scrollbar {
  display: none;
}
.AddComment_AddComment__1hiic .AddComment_CommentContainer__Y7wQ8::-webkit-scrollbar {
  display: none;
}
.AddComment_AddComment__1hiic .AddComment_CommentsButton__CjscF {
  background-color: transparent;
  background-color: initial;
  border: medium none currentColor;
  border: initial;
  cursor: pointer;
  position: relative;
}
.AddComment_AddComment__1hiic .AddComment_CommentsButton__CjscF span {
  position: absolute;
  top: -4px;
  width: 16px;
  height: 16px;
  background-color: var(--secondaryColor);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 50%;
  text-align: center;
  border: 1px solid white;
}
body[dir=ltr] .AddComment_AddComment__1hiic .AddComment_CommentsButton__CjscF span {
  right: 0;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr {
  width: 313px;
  min-height: 173px;
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 30px;
  background-color: var(--bgColor);
  border: 1px solid var(--borderColor);
  padding: 20px;
}
body[dir=ltr] .AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr {
  right: 24px;
}
body[dir=rtl] .AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr {
  left: 24px;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--borderColor);
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr > header h5 {
  text-transform: capitalize;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr > header button {
  background-color: transparent;
  background-color: initial;
  border: medium none currentColor !important;
  border: initial !important;
  min-width: 0 !important;
  min-width: initial !important;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr section header {
  display: flex;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr section header > div {
  -webkit-padding-end: 10px;
          padding-inline-end: 10px;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr section header .AddComment_HeaderInfo__K4h7a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr section header .AddComment_HeaderInfo__K4h7a time {
  font-size: 10px;
  font-weight: 100;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr section p {
  padding: 10px 0 15px;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: auto;
}
.AddComment_AddComment__1hiic .AddComment_CommentBox__ApcEr footer button {
  color: var(--mainColor);
}
.AddComment_AddComment__1hiic .AddComment_ImageContainer__HXMu5 > div {
  height: 32px;
  width: 32px;
  overflow: hidden;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
}
.AddComment_AddComment__1hiic .AddComment_ImageContainer__HXMu5 > div img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.AddComment_AddComment_Description__ugUaF {
  position: absolute;
  bottom: 10px;
  z-index: 1282;
}
body[dir=ltr] .AddComment_AddComment_Description__ugUaF {
  right: 50px;
}
body[dir=rtl] .AddComment_AddComment_Description__ugUaF {
  left: 50px;
}
.AddComment_AddComment_Description_removePosition__8gbZw {
  position: relative;
  top: auto;
  top: initial;
  bottom: auto;
  bottom: initial;
}
body[dir=ltr] .AddComment_AddComment_Description_removePosition__8gbZw {
  right: 65px;
}
body[dir=rtl] .AddComment_AddComment_Description_removePosition__8gbZw {
  left: 65px;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentsButton__CjscF {
  background-color: transparent;
  background-color: initial;
  border: medium none currentColor;
  border: initial;
  cursor: pointer;
  position: relative;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentsButton__CjscF span {
  position: absolute;
  top: -4px;
  width: 16px;
  height: 16px;
  background-color: var(--secondaryColor);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 50%;
  text-align: center;
  border: 1px solid white;
}
body[dir=ltr] .AddComment_AddComment_Description__ugUaF .AddComment_CommentsButton__CjscF span {
  right: 0;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr {
  width: 313px;
  min-height: 173px;
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 30px;
  background-color: var(--bgColor);
  border: 1px solid var(--borderColor);
  padding: 20px;
}
body[dir=ltr] .AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr {
  right: 24px;
}
body[dir=rtl] .AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr {
  left: 24px;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--borderColor);
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr > header h5 {
  text-transform: capitalize;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr > header button {
  background-color: transparent;
  background-color: initial;
  border: medium none currentColor !important;
  border: initial !important;
  min-width: 0 !important;
  min-width: initial !important;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr section header {
  display: flex;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr section header > div {
  -webkit-padding-end: 10px;
          padding-inline-end: 10px;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr section header .AddComment_HeaderInfo__K4h7a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr section header .AddComment_HeaderInfo__K4h7a time {
  font-size: 10px;
  font-weight: 100;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr section p {
  padding: 10px 0 15px;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: auto;
}
.AddComment_AddComment_Description__ugUaF .AddComment_CommentBox__ApcEr button {
  color: var(--mainColor);
}
.AddComment_AddComment_Description__ugUaF .AddComment_ImageContainer__HXMu5 > div {
  height: 32px;
  width: 32px;
  overflow: hidden;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex;
}
.AddComment_AddComment_Description__ugUaF .AddComment_ImageContainer__HXMu5 > div img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.AddComment_Container__iwjy\\+ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.AddComment_HigherZIndex__u8bcz {
  z-index: 1501;
}

#dots-menu:has(button[aria-controls=menu-list-grow]) {
  z-index: 9;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/reports/components/AddComment/AddComment.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAsDF;AArDE;EACE,kBAAA;EACA,SAAA;EAAA,YAAA;EACA,YAAA;EAAA,eAAA;AAuDJ;AArDE;EACE,WAAA;AAuDJ;AArDE;EACE,UAAA;AAuDJ;AArDE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AAuDJ;AArDI;EACE,aAAA;AAuDN;AArDI;EACE,aAAA;AAuDN;AApDE;EACE,6BAAA;EAAA,yBAAA;EACA,gCAAA;EAAA,eAAA;EACA,eAAA;EACA,kBAAA;AAsDJ;AArDI;EACE,kBAAA;EACA,SAAA;EAKA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAmDN;AAhEM;EACE,QAAA;AAkER;AAnDE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAOA,SAAA;EACA,gCAAA;EACA,oCAAA;EACA,aAAA;AA+CJ;AAxDI;EACE,WAAA;AA0DN;AAxDI;EACE,UAAA;AA0DN;AApDI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;AAsDN;AArDM;EACE,0BAAA;AAuDR;AApDM;EACE,6BAAA;EAAA,yBAAA;EACA,2CAAA;EAAA,0BAAA;EACA,uBAAA;EAAA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAsDR;AAjDM;EACE,aAAA;AAmDR;AAjDQ;EACE,yBAAA;UAAA,wBAAA;AAmDV;AAjDQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAmDV;AAlDU;EACE,eAAA;EACA,gBAAA;AAoDZ;AAhDM;EACE,oBAAA;AAkDR;AA/CI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AAiDN;AAhDM;EACE,uBAAA;AAkDR;AA7CI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA+CN;AA9CM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAgDR;;AA3CA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AA8CF;AA5CE;EACE,WAAA;AA8CJ;AA5CE;EACE,UAAA;AA8CJ;AA3CE;EACE,kBAAA;EACA,SAAA;EAAA,YAAA;EACA,YAAA;EAAA,eAAA;AA6CJ;AA3CI;EACE,WAAA;AA6CN;AA3CI;EACE,UAAA;AA6CN;AAzCE;EACE,6BAAA;EAAA,yBAAA;EACA,gCAAA;EAAA,eAAA;EACA,eAAA;EACA,kBAAA;AA2CJ;AA1CI;EACE,kBAAA;EACA,SAAA;EAKA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAwCN;AArDM;EACE,QAAA;AAuDR;AAxCE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAOA,SAAA;EACA,gCAAA;EACA,oCAAA;EACA,aAAA;AAoCJ;AA7CI;EACE,WAAA;AA+CN;AA7CI;EACE,UAAA;AA+CN;AAzCI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;AA2CN;AA1CM;EACE,0BAAA;AA4CR;AAzCM;EACE,6BAAA;EAAA,yBAAA;EACA,2CAAA;EAAA,0BAAA;EACA,uBAAA;EAAA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA2CR;AAtCM;EACE,aAAA;AAwCR;AAtCQ;EACE,yBAAA;UAAA,wBAAA;AAwCV;AAtCQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAwCV;AAvCU;EACE,eAAA;EACA,gBAAA;AAyCZ;AArCM;EACE,oBAAA;AAuCR;AApCI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AAsCN;AApCI;EACE,uBAAA;AAsCN;AAlCI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAoCN;AAnCM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAqCR;;AAhCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAmCF;;AAhCA;EACE,aAAA;AAmCF;;AA/BE;EACE,UAAA;AAkCJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.AddComment {\n  position: absolute;\n  bottom: 10px;\n  z-index: 1282;\n  &_removePosition {\n    position: relative;\n    top: unset;\n    bottom: unset;\n  }\n  #{$ltr} & {\n    right: 10px;\n  }\n  #{$rtl} & {\n    left: 10px;\n  }\n  .CommentContainer {\n    max-height: 130px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n\n    &::scrollbar {\n      display: none;\n    }\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  .CommentsButton {\n    background-color: unset;\n    border: unset;\n    cursor: pointer;\n    position: relative;\n    span {\n      position: absolute;\n      top: -4px;\n      #{$ltr} & {\n        right: 0;\n      }\n\n      width: 16px;\n      height: 16px;\n      background-color: var(--secondaryColor);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      border-radius: 50%;\n      text-align: center;\n      border: 1px solid white;\n    }\n  }\n  .CommentBox {\n    width: 313px;\n    min-height: 173px;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    #{$ltr} & {\n      right: 24px;\n    }\n    #{$rtl} & {\n      left: 24px;\n    }\n    top: 30px;\n    background-color: var(--bgColor);\n    border: 1px solid var(--borderColor);\n    padding: 20px;\n    & > header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      border-bottom: 1px solid var(--borderColor);\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n      h5 {\n        text-transform: capitalize;\n      }\n\n      button {\n        background-color: unset;\n        border: unset !important;\n        min-width: unset !important;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n      }\n    }\n\n    section {\n      header {\n        display: flex;\n\n        & > div {\n          padding-inline-end: 10px;\n        }\n        .HeaderInfo {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          width: 100%;\n          time {\n            font-size: 10px;\n            font-weight: 100;\n          }\n        }\n      }\n      p {\n        padding: 10px 0 15px;\n      }\n    }\n    footer {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-around;\n      margin-top: auto;\n      button {\n        color: var(--mainColor);\n      }\n    }\n  }\n  .ImageContainer {\n    & > div {\n      height: 32px;\n      width: 32px;\n      overflow: hidden;\n      border-radius: 50%;\n      align-items: center;\n      justify-content: center;\n      display: flex;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n      }\n    }\n  }\n}\n.AddComment_Description {\n  position: absolute;\n  bottom: 10px;\n  z-index: 1282;\n\n  #{$ltr} & {\n    right: 50px;\n  }\n  #{$rtl} & {\n    left: 50px;\n  }\n\n  &_removePosition {\n    position: relative;\n    top: unset;\n    bottom: unset;\n\n    #{$ltr} & {\n      right: 65px;\n    }\n    #{$rtl} & {\n      left: 65px;\n    }\n  }\n\n  .CommentsButton {\n    background-color: unset;\n    border: unset;\n    cursor: pointer;\n    position: relative;\n    span {\n      position: absolute;\n      top: -4px;\n      #{$ltr} & {\n        right: 0;\n      }\n\n      width: 16px;\n      height: 16px;\n      background-color: var(--secondaryColor);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      border-radius: 50%;\n      text-align: center;\n      border: 1px solid white;\n    }\n  }\n  .CommentBox {\n    width: 313px;\n    min-height: 173px;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    #{$ltr} & {\n      right: 24px;\n    }\n    #{$rtl} & {\n      left: 24px;\n    }\n    top: 30px;\n    background-color: var(--bgColor);\n    border: 1px solid var(--borderColor);\n    padding: 20px;\n    & > header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      border-bottom: 1px solid var(--borderColor);\n      padding-bottom: 10px;\n      margin-bottom: 10px;\n      h5 {\n        text-transform: capitalize;\n      }\n\n      button {\n        background-color: unset;\n        border: unset !important;\n        min-width: unset !important;\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n      }\n    }\n\n    section {\n      header {\n        display: flex;\n\n        & > div {\n          padding-inline-end: 10px;\n        }\n        .HeaderInfo {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          width: 100%;\n          time {\n            font-size: 10px;\n            font-weight: 100;\n          }\n        }\n      }\n      p {\n        padding: 10px 0 15px;\n      }\n    }\n    footer {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-around;\n      margin-top: auto;\n    }\n    button {\n      color: var(--mainColor);\n    }\n  }\n  .ImageContainer {\n    & > div {\n      height: 32px;\n      width: 32px;\n      overflow: hidden;\n      border-radius: 50%;\n      align-items: center;\n      justify-content: center;\n      display: flex;\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n      }\n    }\n  }\n}\n.Container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.HigherZIndex {\n  z-index: 1501;\n}\n\n:global {\n  #dots-menu:has(button[aria-controls='menu-list-grow']) {\n    z-index: 9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `AddComment_scroll__Shb2V`,
	"AddComment": `AddComment_AddComment__1hiic`,
	"AddComment_removePosition": `AddComment_AddComment_removePosition__bdoTf`,
	"CommentContainer": `AddComment_CommentContainer__Y7wQ8`,
	"CommentsButton": `AddComment_CommentsButton__CjscF`,
	"CommentBox": `AddComment_CommentBox__ApcEr`,
	"HeaderInfo": `AddComment_HeaderInfo__K4h7a`,
	"ImageContainer": `AddComment_ImageContainer__HXMu5`,
	"AddComment_Description": `AddComment_AddComment_Description__ugUaF`,
	"AddComment_Description_removePosition": `AddComment_AddComment_Description_removePosition__8gbZw`,
	"Container": `AddComment_Container__iwjy+`,
	"HigherZIndex": `AddComment_HigherZIndex__u8bcz`
};
export default ___CSS_LOADER_EXPORT___;
